import * as React from 'react';
import styled from "styled-components";
import {transition} from "helpers/css";
import {
  FacebookIcon,
  InstagramIcon,
  TelegramIcon,
  VkontakteIcon
} from "./icons";
import {navigateTo} from "helpers/navigate-to";

const Wrapper = styled.div`
  display: flex;
  background: #2A2A2B;
  padding: 40px 90px 40px 10px;
  margin-top: 40px;
  color: white;

  @media screen and (max-width: 840px) {
    padding: 30px 20px;
  }
`;

const GroupTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 27px;
  letter-spacing: 0.01em;
  margin-bottom: 10px;
`;

const GroupItem = styled.div`
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.8);
  
  &:hover {
    color: white;
    cursor: pointer;
  }
`;

const SocialsGroup = styled.div`
  display: grid;
  grid-template-columns: repeat(4, max-content);
  gap: 20px;
  margin: 20px 0;
`;

const Buttons = styled.div`
  display: grid;
  grid-template-columns: max-content;
  gap: 10px;
  height: max-content;

  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: 0.01em;
`;

const Button = styled.a<{primary?: boolean}>`
  box-sizing: border-box;
  background: ${({primary}) => primary ? '#3264EF' : 'transparent'};
  padding: 10px;
  min-width: 200px;
  text-align: center;
  border-radius: 5px;
  
  border-width: 1px;
  border-style: solid;
  border-color: ${({primary}) => primary ? 'transparent' : '#444444'};
  cursor: pointer;

  ${transition()};

  &:hover {
    background-color: ${({primary}) => primary 
        ? 'rgb(74,125,255)' 
        : 'rgba(255,255,255,0.05)'};
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Owner = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.01em;
  color: rgba(255, 255, 255, 0.8);
`

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin: auto;
  width: 100%;
  max-width: 1340px;
  padding-left: 90px;

  @media screen and (max-width: 840px) {
    padding: 0;
  }

  @media screen and (max-width: 650px) {
    flex-direction: column;
    gap: 20px;
    
    ${Owner} {
      margin-top: 20px;
    }
  }
`;

/**
 * render landing page footer
 * @constructor
 */
export default function Footer(): React.ReactElement {
  return (
    <Wrapper>
      <Container>
        <div>
          <GroupTitle>Навигация</GroupTitle>
          {/*
          <GroupItem onClick={() => navigateTo('landing.blog')}>Блог</GroupItem>
          */}
          <GroupItem onClick={() => navigateTo('landing.about')}>О компании</GroupItem>
          <GroupItem onClick={() => navigateTo('landing.faq')}>FAQ</GroupItem>
        </div>
        <div>
          <GroupTitle>Контакты</GroupTitle>
          <GroupItem>
            Служба заботы
            <br/>
            <b>care@grow-place.com</b>
          </GroupItem>
          <GroupItem>
            Предложения
            <br/>
            <b>partners@grow-place.com</b>
          </GroupItem>
          <SocialsGroup>
              <VkontakteIcon />
              <InstagramIcon />
              <TelegramIcon />
              <FacebookIcon />
          </SocialsGroup>
          <GroupItem>ИНН 246521363326</GroupItem>
          <GroupItem>Реквизиты</GroupItem>
          <GroupItem>Политика конфиденциальности</GroupItem>
        </div>
        <Section>
          <Buttons>
            <Button
              primary
              onClick={() => navigateTo('register')}
            >Зарегистрироваться</Button>
            <Button
              onClick={() => navigateTo('login')}
            >Войти</Button>
            <Button
              onClick={() => navigateTo('landing.feedback')}
            >Предложить идею</Button>
          </Buttons>
          <Owner>powered by shumann</Owner>
        </Section>
      </Container>
    </Wrapper>
  );
}
